import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { withApollo } from 'react-apollo';
import { AppContext } from '../../AppProvider';
import Table from '../../components/Global/Table/Table';
import ListIcon from '@material-ui/icons/List';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import classNames from 'classnames';
import PermitButton from '../../components/Global/Buttons/PermitButton';
import SelectInput from '../../components/Global/Inputs/Select';
import * as Queries from '../../graphQL/queries/shipmentQueries';
import MultiPointMap from '../../components/Global/Maps/MultiPointMap';
import ErrorNotification from '../../components/common/ErrorNotification';
import * as helpers from './helpers';
import ShipmentIndexStyles from './ShipmentIndex.styles';
import TableRow from './TableRow';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import _isNumber from 'lodash/isNumber';
import { DEFAULT_ROWS_PER_PAGE } from '../../constants/constants';
import { buildDropdown } from '../../utils/Shipment';
import { buildSortCriteriaForDSL } from '../../utils/queryHelpers';
import moment from 'moment';
import PickCustomDateModal from '../../components/Global/Inputs/PickCustomDateModal';

import { SHIPMENT_SAVE } from '../../constants/permissions';

const DISPLAY_LIST = 'list';
const DISPLAY_MAP = 'map';
const ASCENDING = 'asc';

const CUSTOM_DATE = 'pickCustomDate';

export class ShipmentIndex extends Component {
  state = {
    page: 0,
    rowsPerPage: localStorage.getItem('PropelRowsPerPage')
      ? parseInt(localStorage.getItem('PropelRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    displaySection: DISPLAY_LIST,
    shipments: [],
    totalCount: 0,
    loading: true,
    error: null,
    shipmentDirections: [],
    shipmentStatuses: [],
    openPickCustomDate: null,
    filters: {
      Status: 'all',
      PickupDate: 'all',
      DeliveryDate: 'all'
    },
    shipmentSort: [{ columnName: 'id', direction: ASCENDING }],
    tableColumns: []
  };
  /*
  shouldComponentUpdate(nextProps, nextState) {
    //TODO - NOTE: this logic will need to change once we have subscriptions going that return changes in statuses, etc. for
    // shipments that are displayed.  Since we don't know what we don't know on how this will work right now we'll have to wait
    // to add that logic.  In the end we'll need something that tells us that there was an in-place update to a shipment on the screen.

    // Don't update if nothing changed in the list.  This will prevent a re-render if they click elsewhere on the screen
    // outside the list itself (e.g. one of the expandable options in the sidebar).
    if (
      this.state.rowsPerPage === nextState.rowsPerPage &&
      this.state.page === nextState.page &&
      !this.state.loading
    ) {
      return false;
    }
    return true;
  }
 */
  _changePage = page => {
    this.setState({ page, loading: true }, this.getShipmentList);
  };
  _changeRowsPerPage = rowsPerPage => {
    localStorage.setItem('PropelRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 0 });
    const rows = rowsPerPage === 0 ? DEFAULT_ROWS_PER_PAGE : rowsPerPage;
    this.setState(
      { rowsPerPage: rows, page: 0, loading: true },
      this.getShipmentList
    );
  };
  _handlePageDisplaySection = displaySection => {
    this.setState({ displaySection });
  };
  async componentDidMount() {
    const { t } = this.props;

    this._getFiltersDropDownValues();
    this.setState({ tableColumns: helpers.columns(t) }, this.getShipmentList);
  }

  async getShipmentList() {
    const { client: ApolloClient } = this.props;
    const { shipmentStatuses } = this.context.globalProps.referenceData;
    const { currentOrgId } = this.context.globalProps;
    const { page, rowsPerPage, shipmentSort, tableColumns } = this.state;
    const offset = page * rowsPerPage;
    let query = this._getQueryString();
    if (query) {
      query = `WHERE ${query}`;
    }
    const sortString = buildSortCriteriaForDSL(shipmentSort, tableColumns);
    this.setState({ loading: true });

    try {
      const {
        data: {
          shipment: {
            pagedQuery: { results: shipmentRows, totalCount }
          }
        }
      } = await ApolloClient.query({
        query: Queries.allShipmentsIndex,
        fetchPolicy: 'network-only',
        variables: {
          orgId: currentOrgId,
          limit: rowsPerPage,
          offset,
          query: `FROM ShipmentSummary Select * ${query} ${sortString}`
        }
      });
      const shipments = helpers.formatShipments(shipmentRows, shipmentStatuses);
      this.setState({
        shipments,
        totalCount: _isNumber(totalCount) ? totalCount : this.state.totalCount,
        loading: false
      });
    } catch (error) {
      this.setState({ error });
    }
  }

  _getQueryString = () => {
    const { Status, PickupDate, DeliveryDate } = this.state.filters;
    const filters = [];
    if (Status && Status !== 'all') {
      filters.push(`Status = "${Status}"`);
    }
    if (PickupDate && PickupDate !== 'all') {
      const [startDate, endDate] = PickupDate.split(' - ');
      if (startDate && endDate) {
        filters.push(`PickupDate BETWEEN "${startDate}" and "${endDate}"`);
      }
      if (startDate && !endDate) {
        filters.push(`PickupDate = "${startDate}"`);
      }
    }
    if (DeliveryDate && DeliveryDate !== 'all') {
      const [startDate, endDate] = DeliveryDate.split(' - ');
      if (startDate && endDate) {
        filters.push(`DeliveryDate BETWEEN "${startDate}" and "${endDate}"`);
      }
      if (startDate && !endDate) {
        filters.push(`DeliveryDate = "${startDate}"`);
      }
    }
    return filters.join(' AND ');
  };

  _getFiltersDropDownValues = () => {
    const {
      referenceData: { shipmentDirections, shipmentStatuses }
    } = this.props.globals;
    this.setState({
      shipmentDirections,
      shipmentStatuses: buildDropdown(shipmentStatuses, 'name', 'name')
    });
  };

  _handleFilter = ({ target: { name, value } }) => {
    this.setState(
      {
        openPickCustomDate: null,
        filters: {
          ...this.state.filters,
          [name]: value
        }
      },
      this.getShipmentList
    );
  };

  _handleDateFilter = ({ target: { name, value } }) => {
    if (value === CUSTOM_DATE) {
      this.setState({ openPickCustomDate: name });
    } else {
      this.setState(
        {
          filters: {
            ...this.state.filters,
            [name]: value
          }
        },
        this.getShipmentList
      );
    }
  };

  _handleClosePickCustomDate = () =>
    this.setState({ openPickCustomDate: null });

  _handleSortChange = newSort => {
    this.setState({ shipmentSort: newSort }, this.getShipmentList);
  };

  _handleDownloadCSV = async () => {    
    window.open(`${process.env.PUBLIC_URL}/shipments.csv`, '_blank');


    // const { shipmentSort } = this.state;
    // const { currentOrgId } = this.context.globalProps;
    // let query = this._getQueryString();
    // if (query) {
    //   query = `WHERE ${query}`;
    // }
    // const FIRST_SORT_COLUMN = 0;
    // const sortDirection =
    //   shipmentSort[FIRST_SORT_COLUMN].direction === ASCENDING ? 'asc' : 'desc ';
    // const sort = `order by ${
    //   shipmentSort[FIRST_SORT_COLUMN].columnName
    // } ${sortDirection}`;
    // const shipmentQuery = `${query} ${sort}`;
    // await helpers.downloadCSV(currentOrgId, shipmentQuery);
  };
  render() {
    const { classes, t } = this.props;
    const {
      page,
      rowsPerPage,
      displaySection,
      loading: dataLoading,
      shipments,
      totalCount,
      error,
      shipmentSort,
      tableColumns
    } = this.state;

    if (error) {
      return <ErrorNotification message="Error loading page" />;
    }

    return (
      <Fragment>
        <div className={classes.toolBarRootPage}>
          <h1 className={classes.pageTitle}>{t('Shipments')}</h1>
          <div className={classes.actionWrapper}>
            <div className={classes.contentOptions}>
              <div aria-label="list-view" className={classes.iconContainer}>
                <IconButton
                  onClick={() => this._handlePageDisplaySection(DISPLAY_LIST)}
                  classes={{
                    root: classes.buttonsRoot
                  }}
                  color={
                    displaySection === DISPLAY_LIST ? 'primary' : 'default'
                  }
                >
                  <ListIcon className={classNames(classes.contentOption)} />
                </IconButton>
              </div>
              <div className={classes.verticalDivider} />
              <div aria-label="map-view" className={classes.iconContainer}>
                <IconButton
                  onClick={() => this._handlePageDisplaySection(DISPLAY_MAP)}
                  classes={{
                    root: classes.buttonsRoot
                  }}
                  color={displaySection === DISPLAY_MAP ? 'primary' : 'default'}
                >
                  <MapOutlinedIcon
                    className={classNames(classes.contentOption)}
                  />
                </IconButton>
              </div>
            </div>
            <div className={classes.actions}>
              <PermitButton
                variant="contained"
                color="primary"
                className={classes.actionButton}
                to="/shipments/new"
                permission={SHIPMENT_SAVE}
              >
                {t('Create Shipment')}
              </PermitButton>
            </div>
          </div>
        </div>
        <div className={classes.filterOptionsWrapper}>
          <SelectInput
            native={false}
            classes={{
              root: classes.selectRoot,
              filterColor: classes.filterColor
            }}
            name={'Status'}
            options={[
              { value: 'all', title: 'All' },
              ...this.state.shipmentStatuses
            ]}
            onChange={this._handleFilter}
            inputLabel={'Status'}
            defaultValue={this.state.filters.Status}
          />
          <SelectInput
            native={false}
            name={'PickupDate'}
            options={[
              { value: 'all', title: 'All' },
              { value: moment().format('YYYY-MM-DD'), title: 'Today' },
              {
                value: `${moment()
                  .startOf('week')
                  .format('YYYY-MM-DD')} - ${moment()
                  .endOf('week')
                  .format('YYYY-MM-DD')}`,
                title: 'This Week'
              },
              {
                value: `${moment()
                  .startOf('month')
                  .format('YYYY-MM-DD')} - ${moment()
                  .endOf('month')
                  .format('YYYY-MM-DD')}`,
                title: 'This Month'
              },
              { value: CUSTOM_DATE, title: 'Custom Date' }
            ]}
            defaultValue={this.state.filters.PickupDate}
            classes={{
              root: classes.selectRoot,
              filterColor: classes.filterColor
            }}
            inputLabel={'Pickup Date'}
            onChange={this._handleDateFilter}
          />
          <SelectInput
            native={false}
            name={'DeliveryDate'}
            options={[
              { value: 'all', title: 'All' },
              { value: moment().format('YYYY-MM-DD'), title: 'Today' },
              {
                value: `${moment()
                  .startOf('week')
                  .format('YYYY-MM-DD')} - ${moment()
                  .endOf('week')
                  .format('YYYY-MM-DD')}`,
                title: 'This Week'
              },
              {
                value: `${moment()
                  .startOf('month')
                  .format('YYYY-MM-DD')} - ${moment()
                  .endOf('month')
                  .format('YYYY-MM-DD')}`,
                title: 'This Month'
              },
              { value: CUSTOM_DATE, title: 'Custom Date' }
            ]}
            defaultValue={this.state.filters.DeliveryDate}
            classes={{
              root: classes.selectRoot,
              filterColor: classes.filterColor
            }}
            inputLabel={'Delivery Date'}
            onChange={this._handleDateFilter}
          />
        </div>
        {displaySection === DISPLAY_LIST && (
          <div>
            <Table
              name={t('Shipment')}
              columns={tableColumns}
              data={shipments}
              withDownload={true}
              onDownloadClick={this._handleDownloadCSV}
              orderBy="id"
              order={'desc'}
              onChangePage={this._changePage}
              onChangePageRowsPerPage={this._changeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              rowComponent={TableRow}
              sort={shipmentSort}
              onSortChange={this._handleSortChange}
              totalCount={totalCount}
              loading={dataLoading}
              defaultHiddenColumnNames={[
                'plannedPickup',
                'projectedPickup',
                'actualPickup',
                'plannedDelivery',
                'projectedDelivery',
                'actualDelivery',
                'direction'
              ]}
            />
          </div>
        )}
        {displaySection === DISPLAY_MAP && (
          <Paper>
            <MultiPointMap shipments={shipments} mapId="shipmentIndex" />
          </Paper>
        )}
        {Boolean(this.state.openPickCustomDate) && (
          <PickCustomDateModal
            name={this.state.openPickCustomDate}
            onClose={this._handleClosePickCustomDate}
            onSave={this._handleFilter}
            value={this.state.filters[this.state.openPickCustomDate]}
          />
        )}
      </Fragment>
    );
  }
}

ShipmentIndex.contextType = AppContext;
export const translatedShipmentIndex = withNamespaces()(ShipmentIndex);
export default withStyles(ShipmentIndexStyles)(
  withApollo(translatedShipmentIndex)
);
